import React, { useState } from 'react'
import List from 'react-list-select'

import Modal from 'components/lib/DesignSystem/Modal'

function AddLanguage(props) {
  const [selected, setSelected] = useState(null)

  const handleClose = () => {
    setSelected(null)
    props.handleModalClose()
  }

  const handleApply = () => {
    const langIds = props.newLanguageOptions.map((op) => op.value)
    props.onNewLanguageSelect(langIds[selected])
    setSelected(null)
  }

  const { newLanguageOptions, showDialog } = props

  const items = newLanguageOptions.map((op) => op.label)

  return (
    <Modal
      open={showDialog}
      onClose={handleClose}
      title="Select Language"
      id="Settings_End_Users_Add_Language_Modal"
      confirm={handleApply}
      customConfirmYes="Done"
      customConfirmNo="Cancel"
      height="400px"
      confirmDisabled={selected === null}
    >
      {items.length ? (
        <List
          className="modal-list"
          items={items}
          selected={[selected]}
          onChange={(s) => setSelected(s)}
        />
      ) : (
        <div className="tac sb">No language to add</div>
      )}
    </Modal>
  )
}

export default AddLanguage
